import { useNavigate, useLocation } from "react-router-dom";
import { GuardProps } from "types";
import { useEffect } from "react";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const token = localStorage.getItem("user-token");
  const loginCredentials = JSON.parse(
    localStorage.getItem("login-credentials") ?? "{}"
  );
  const isAdmin = loginCredentials.name === "admin" ? true : false;

  useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
    } else if (isAdmin && pathname.startsWith("/user")) {
      navigate("/admin/dashboard", { replace: true });
    } else if (!isAdmin && pathname.startsWith("/admin")) {
      navigate("/user/dashboard", { replace: true });
    }
  }, [navigate, token, isAdmin, pathname]);

  return children;
};

export default AuthGuard;
